require("./compile/unminified/ng-img-crop.js");
module.exports = "ngImgCrop";
